/**
 * @see mockMd/union_city_war_pendant.md
 */
import {
  UnionCityWarActivityName,
  UnionCityWarPendantWeight,
  type UnionCityWarPendantCity,
  type UnionCityWarPendantData,
  type UnionCityWarPendantPk,
  type UnionCityWarPendantTop1,
} from '../types'
import {storiesAvatar} from '../tasks-docs/room-pendant/stories-images'

const PENDANT_URL =
  'hiya://openWindow?need_user_info=1&fullscreen=0&external=0&from=pendant&url=https%3A%2F%2Fexample.com%2Fact'

export const UnionCityWarPendantPkMock: UnionCityWarPendantPk = {
  own_city_level: 50,
  opponent_city_level: 45,
  own_score: 12334455,
  opponent_score: 27180395,
}

export const UnionCityWarPendantCityMock: UnionCityWarPendantCity = {
  city_level: 50,
  city_score: 50,
  next_level_score: 100000,
}

export const UnionCityWarPendantTop1Mock: UnionCityWarPendantTop1 = {
  union_avatar: storiesAvatar,
  city_score: 12334455,
}

const basePendant = {
  activity_name: UnionCityWarActivityName.UnionCityWar,
  activity_id: 123456,
  image: '',
  url: PENDANT_URL,
  weight: UnionCityWarPendantWeight.Default,
}

export const UnionCityWarPendantAnchorPkMock: UnionCityWarPendantData = {
  ...basePendant,
  pk: UnionCityWarPendantPkMock,
  top1: UnionCityWarPendantTop1Mock,
}

export const UnionCityWarPendantAnchorCityMock: UnionCityWarPendantData = {
  ...basePendant,
  city: UnionCityWarPendantCityMock,
  top1: UnionCityWarPendantTop1Mock,
}

export const UnionCityWarPendantGuestMock: UnionCityWarPendantData = {
  ...basePendant,
  top1: UnionCityWarPendantTop1Mock,
}

export const UnionCityWarPendantMock = UnionCityWarPendantAnchorPkMock
